import dayjs from "dayjs";
import { parseDate, formatDate, DISPLAY_FORMAT } from "../../helpers/dateHelper";

export const createReportFromApiReponse = (bookings) => {
  let response = {
    flights: [],
    hotels: [],
    buses: [],
    activities: [],
  };
  bookings.forEach((booking) => {
    if (booking.type === "Bus") {
      const dateObj = dayjs(booking.journeyDate, "DD-MM-YYYY");
      booking.month = dateObj.month();
      booking.year = dateObj.year();
      booking.formatedDate = booking.journeyDate;
    } else {
      const dateObj = parseDate(booking.journeyDate);
      booking.month = dateObj ? dateObj.month() : 0;
      booking.year = dateObj ? dateObj.year() : 0;
      booking.formatedDate = formatDate(booking.journeyDate, DISPLAY_FORMAT);
    }

    if (booking.type == "Hotel" && booking.BookingStatus == "CONFIRMED") {
      response.hotels.push(booking);
    } else if (
      booking.type == "Flight" &&
      booking.BookingStatus == "CONFIRMED"
    ) {
      response.flights.push(booking);
    } else if (booking.type == "Bus" && booking.BookingStatus == "CONFIRMED") {
      response.buses.push(booking);
    } else if (
      booking.type == "Activities" &&
      booking.BookingStatus == "CONFIRMED"
    ) {
      response.activities.push(booking);
    }
  });

  return response;
};
